



window.Tour = ReactiveComponent
  displayName: 'Tour'

  render: -> 

    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 700

    DIV null,          
      Basics()

      DIV 
        style: 
          position: 'relative'
          zIndex: 2
          backgroundColor: 'white'
          boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)'
          paddingTop: 30
          paddingBottom: 70

        Features
          features: tab_features
        
        Research()   


steps = [
  {
    header: 'Create a forum for your community'
    beginning: """Your new Consider.it forum will 
                  initially be empty and lonely! That’s ok, it will soon be humming 
                  with activity. Think about who you’re seeking to engage. Then post questions or 
             ideas you’d like your community to think through. """
    desc: """Now you’re ready 
             to invite your community! Just share the forum link with your community via email or social media. 
          """
    #img: 'product_page/wsffn_example.png'
    movie: 'step1-produced'
    browser_loc: '' #'https://wpc.consider.it'
    movie_caption: 'Creating your own forum'
  }
  {
    header: 'Stakeholders express considered opinions'
    beginning: 'Consider.it gets your community on the same page (literally). Areas of disagreement and agreement are clear, as well as the underlying rationale, so you can take more effective action.' #'Your community is now deliberating the topics you added!'
    desc: """Consider.it helps each participant create a considered opinion that 
             expresses <b>what they believe</b> (on a sliding scale) and <b>why</b> (their 
             most critical pros and cons). Each pro or con point a participant 
             adds contributes to future participants' understanding. 
             Your community gets smarter together. 
          """
    movie: 'step2-produced'
    browser_loc: 'https://washington-policy-coalition.consider.it'
    movie_caption: 'Community deliberation'
  }
  {

    #header: 'Explore patterns of thought for deeper understanding'
    header: 'Slice & dice opinions for deep understanding'
    beginning: 'Explore what your community thinks! For example, you can easily learn the reservations of those who oppose a proposal. Perhaps 80% of those whom oppose share two concerns that can be resolved, making the pathway to consensus clear!' #'Consider.it gets your community on the same page (literally). Areas of disagreement and agreement are clear, as well as the underlying rationale, so you can take more effective action.'
    desc: """<p>Those are the basics! It is now up to you and your community to use this mutual understanding to make decisions and advance your mission.</p> 
             <p><b>Perhaps you'd like to <a href="/create_forum">start your own forum</a> now?</b></p> 
          """
    movie: 'step3-produced'
    browser_loc: 'https://washington-policy-coalition.consider.it'
    movie_caption: 'Slicing & dicing opinions'
  }

]

Basics = ReactiveComponent
  displayName: 'Basics'

  render: ->    
    if !@local.current_step?
      @local.current_step = 0 

    DIV 
      style: 
        width: SAAS_PAGE_WIDTH()
        margin: 'auto'
        padding: '40px 12px 60px 12px'
        minHeight: 870
        
      A 
        name: 'basics'

      H1
        style: 
          fontSize: 50
          fontWeight: 800
          color: 'white'
          textAlign: 'center'
          textShadow: '0px 2px 4px rgba(0,0,0,.2)'

        "Let’s step through the basics"
        #"3 Steps to community engagement"
    
      DIV 
        style: 
          width: '100%'
          zIndex: 2
          position: 'relative'
          top: 2
          marginTop: 28
          marginBottom: 42 

        TABLE 
          ref: 'tabs'
          role: 'tablist'
          style: 
            width: SAAS_PAGE_WIDTH()
            maxWidth: 860
            margin: 'auto'
            #textAlign: 'center'
            listStyle: 'none'

          TBODY null, TR null,

            for step,idx in steps
              do (step, idx) => 
                current = idx == @local.current_step
                TD 
                  tabIndex: 0
                  role: 'tab'
                  style: 
                    #display: 'inline-block'
                    #maxWidth: 160
                    opacity: if !current then 0.4
                    fontSize: 25
                    fontWeight: 700
                    padding: '0px 16px'
                    color: 'white'
                    cursor: 'pointer'
                    fontStyle: 'oblique'
                    position: 'relative'
                    textDecoration: if current then 'underline'
                    width: '33%'
                    position: 'relative'

                  'aria-controls': 'step'
                  'aria-selected': current

                  onKeyDown: (e) => 
                    if e.which == 13 || e.which == 32 # ENTER or SPACE
                      e.currentTarget.click() 
                      e.preventDefault()
                  onClick: => 
                    @local.current_step = idx
                    @local.playing = null
                    @local.finished = false 
                    save @local

                    document.activeElement.blur()

                  DIV 
                    style: 
                      position: 'absolute'
                      left: 4

                    "#{idx + 1}."

                  DIV 
                    style: 
                      paddingLeft: 16

                    step.header

      DIV 
        id: 'step'
        # H2
        #   style: 
        #     fontSize: 28
        #     fontWeight: 800
        #     color: 'white'
        #     textAlign: 'center'
        #     maxWidth: 675
        #     margin: 'auto'
        #     paddingBottom: 24

        #   steps[@local.current_step].header

        if steps[@local.current_step].beginning
          DIV 
            className: 'embedded'
            style: 
              paddingBottom: 24            
              fontSize: 22
              color: 'white'
              maxWidth: 675
              margin: 'auto'
              fontStyle: 'oblique'
            dangerouslySetInnerHTML: __html: steps[@local.current_step].beginning

        if steps[@local.current_step].img 
          Webframe 
            browser_loc: steps[@local.current_step].browser_loc
            width: 675
            DIV 
              style: 
                width: '90%'
                margin: 'auto'

              IMG 
                src: asset steps[@local.current_step].img 
                style:
                  width: '100%'
        else if steps[@local.current_step].movie
          activate = => 
            @local.hovering = true 
            save @local 
          inactivate = => 
            @local.hovering = false 
            save @local 

          Webframe 
            browser_loc: steps[@local.current_step].browser_loc
            width: 675
            dummy: @local.hovering
            dummy2: @local.current_step
            dummy3: @local.playing
            key: @local.current_step

            DIV 
              style: 
                width: '100%'
                margin: 'auto'
                position: 'relative'
                backgroundColor: 'black'

              VIDEO
                key: @local.current_step
                ref: 'video'
                preload: true
                loop: false
                autoPlay: false
                controls: if @local.hovering && @local.playing then true else null
                style: _.extend {}, (if !@local.playing then css.grayscale({}) else {}),
                  position: 'relative'
                  width: '100%'
                  height: 3/7 * 675
                  #height: Math.min(1080/1920 * (SAAS_PAGE_WIDTH() - 80), 800 * 1080/1920, @local.video_height or 0)
                  display: 'block'
                  opacity: if !@local.playing then .4
                  backgroundColor: if !@local.playing then 'black'
                onMouseEnter: activate 
                onMouseLeave: inactivate
                onKeyPress: (e) => 
                  if e.which == 32 || e.which == 13
                    if @local.hovering
                      inactivate()
                    else 
                      activate()


                for format in ['mp4', 'webm']
                  asset_path = asset("product_page/#{steps[@local.current_step].movie}.#{format}")
                  if asset_path?.length > 0
                    SOURCE
                      key: format
                      src: asset_path
                      type: "video/#{format}"

                "Your browser does not support the video element."

              if !@local.playing
                play_video = => 
                  e = => 
                    @local.playing = false
                    @local.finished = true
                    save @local
                    @refs.video.getDOMNode().removeEventListener 'ended', e

                  @refs.video.getDOMNode().play()
                  @refs.video.getDOMNode().addEventListener 'ended', e

                  @local.playing = true
                  @local.hovering = true 
                  @local.finished = false
                  save @local

                DIV 
                  style: 
                    backgroundColor: 'rgb(162, 98, 162)' #primary_color() #'black'
                    borderRadius: 8
                    boxShadow: '0px 2px 4px rgba(0,0,0,.4)'
                    position: 'absolute'
                    top: '35%'
                    left: '50%'
                    marginLeft: -326 / 2

                    color: 'white'
                    cursor: 'pointer'
                    padding: '14px 22px'
                  onClick: play_video
                  onKeyPress: (e) => 
                    if e.which == 32 || e.which == 13
                      play_video()

                  if !@local.finished
                    SVG 
                      width: 34
                      height: 41
                      viewBox: "25 25 34 41" 
                      
                      
                      POLYGON 
                        stroke: "none" 
                        fill: "#FFFFFF" 
                        transform: "translate(42.000000, 45.500000) rotate(90.000000) translate(-42.000000, -45.500000) " 
                        points: "42 29 62 62 22 62"
                  else 
                    SPAN 
                      style: 
                        color: 'white'
                        fontSize: 50
                      '⟲'

                  DIV 
                    style: 
                      display: 'inline-block'
                      paddingLeft: 24
                    DIV   
                      style: 
                        fontWeight: 600
                        fontSize: 16
                      if @local.finished
                        'Replay'
                      else 
                        "Play (silent) video"

                    DIV 
                      style: 
                        fontSize: 20
                        paddingTop: 2

                      steps[@local.current_step].movie_caption



        DIV 
          className: 'embedded'
          style: 
            paddingTop: 32
            fontSize: 22
            color: 'white'
            maxWidth: 675
            margin: 'auto'
            fontStyle: 'oblique'
          dangerouslySetInnerHTML: __html: steps[@local.current_step].desc

        if @local.current_step < steps.length - 1
          DIV 
            style: 
              textAlign: 'right'
              maxWidth: 675
              margin: 'auto'
            BUTTON  
              style: 
                backgroundColor: 'transparent'
                border: 'none'
                color: 'white'
                fontSize: 28
                fontWeight: 800
              onClick: => 
                @local.current_step++
                @local.playing = null
                save @local 
                $(@refs.tabs.getDOMNode()).ensureInView({scroll:true})
              onKeyPress: (e) => 
                if e.which == 32 || e.which == 13
                  @local.current_step++
                  @local.playing = null
                  @local.finished = false
                  save @local 
                  $(@refs.tabs.getDOMNode()).ensureInView({scroll:true})                  
                  e.stopPropagation()
                  e.preventDefault()
              SPAN 
                style: 
                  textDecoration: 'underline'
                'Next step'
              ' >'


Features = ReactiveComponent
  displayName: 'Features'

  render: -> 
    loc = fetch 'location'
    loc.query_params.feature ?= @props.features[0].id

    for f in @props.features
      if f.id == loc.query_params.feature
        current_feature = f

    DIV 
      id: 'features'
      style: 
        minWidth: 600

      H2 
        style: 
          fontSize: 42
          fontWeight: 800        
          padding: '60px 20px 32px 20px'
          fontStyle: 'oblique'
          textAlign: 'center'

        if SAAS_PAGE_WIDTH() < 800

          SPAN 
            style: 
              color: primary_color()
            'Does Consider.it offer...'

        else 
          [
            # SPAN 
            #   style: 
            #     color: '#8D8E8D'
            #   'Consider.it may work for me,'

            # SPAN 
            #   style: 
            #     color: primary_color()
            #   ' but does it offer...'
            
            SPAN 
              style: 
                color: '#8D8E8D'
              'Ok, I get the basics,'

            SPAN 
              style: 
                color: primary_color()
              ' but does Consider.it offer...'

          ]

      TABLE 
        
        style: 
          marginLeft: 60
        TBODY null, TR null,
          TD 
            style: 
              paddingLeft: 0
              paddingRight: 0
          
            UL 
              role: 'tablist'
              style: 
                listStyle: 'none'

              for feature, idx in @props.features
                do (feature, idx) => 
                  current = feature == current_feature
                  LI 
                    tabIndex: 0
                    role: 'tab'
                    style: 
                      display: 'block'
                      #maxWidth: 160
                      fontSize: 28
                      fontWeight: 800
                      padding: '12px 24px 12px 12px'
                      cursor: 'pointer'
                      fontStyle: 'oblique'
                      position: 'relative'
                      textAlign: 'right'
                      color: if current then primary_color() else '#d1d1d1'
                      #textDecoration: if current then 'underline'
                      textTransform: 'lowercase'
                      backgroundColor: if current then '#EFEFEF'
                    'aria-controls': 'features_cell'
                    'aria-selected': current

                    onKeyDown: (e) => 
                      if e.which == 13 || e.which == 32 # ENTER or SPACE
                        e.currentTarget.click() 
                        e.preventDefault()
                    onClick: (e) => 
                      e.stopPropagation()
                      e.preventDefault()
                      loc.query_params.feature = feature.id
                      save loc 

                      document.activeElement.blur()

                    feature.label + '?'


          TD 
            id: 'features_cell'
            style:
              backgroundColor: '#EFEFEF'
              paddingTop: 24
              paddingBottom: 24
            Feature 
              key: current_feature.label
              feature: current_feature 


      DIV 
        className: 'embedded'
        style: 
          fontSize: 18
          fontStyle: 'italic'
          padding: '18px 60px'
          color: '#777'
          textAlign: 'center'
        dangerouslySetInnerHTML: 
          __html: """If you don’t 
                     see a feature you need listed above, 
                     <a href='/contact'>reach out and ask</a> about it!"""



Feature = ReactiveComponent
  displayName: 'Feature'

  render: -> 
    feature = @props.feature

    has_media = !!feature.img || !!feature.video || !!feature.testimonial

    activate = => 
      @local.hovering = true 
      save @local 
    inactivate = => 
      @local.hovering = false 
      save @local 


    DIV 
      className: 'feature'
      'data-id': feature.id    
      style: 
        #padding: 40
        position: 'relative'

      A name: feature.id


      DIV 
        style: 
          maxWidth: 800
          margin: 'auto'
          padding: '0 48px'
        # if feature.label 
        #   H3
        #     style: 
        #       fontSize: 32
        #       fontWeight: 700
        #       marginBottom: 16
        #     feature.label

        if feature.html 
          DIV 
            className: 'embedded'
            style: 
              fontSize: 20
              color: '#666'
              fontWeight: 500
              #fontStyle: 'oblique'
            dangerouslySetInnerHTML: {__html: feature.html}

        if feature.paid
          DIV 
            style: 
              paddingTop: 18
              fontSize: 20
              color: primary_color()
              paddingBottom: 12
            "Available in the "
            A 
              href: '/pricing'
              style: 
                textDecoration: 'underline'
                fontWeight: 700

              'Unlimited or Enterprise plan'

        if has_media
          boxShadow = if !feature.testimonial
                        '0 1px 4px rgba(0,0,0,.25)' 
                      else 
                        null
          DIV 
            style:  
              verticalAlign: 'top'
              lineHeight: 0
              margin: '8px auto 20px auto'

            if feature.img 
              is_gif = feature.img.indexOf('.gif') > -1
              sty = 
                width: '100%'
                backgroundColor: 'white'
                transition: if is_gif then 'opacity 500ms'
                boxShadow: boxShadow
                transition: 'box-shadow 500ms'

              IMG 
                src: feature.img 
                style: sty

            else if feature.video

              VIDEO
                ref: 'video'
                preload: true
                loop: true
                autoPlay: true
                controls: if @local.hovering then true else null
                style: 
                  position: 'relative'
                  width: Math.min(SAAS_PAGE_WIDTH() - 80, 800, @local.video_height * 1920/1080)
                  height: Math.min(1080/1920 * (SAAS_PAGE_WIDTH() - 80), 800 * 1080/1920, @local.video_height or 0)
                  boxShadow: boxShadow
                  transition: 'box-shadow 500ms'
                  display: 'block'
                onMouseEnter: activate 
                onMouseLeave: inactivate
                onKeyPress: (e) => 
                  if e.which == 32 || e.which == 13
                    if @local.hovering
                      inactivate()
                    else 
                      activate()


                for format in ['mp4', 'webm']
                  asset_path = asset("product_page/#{feature.video}.#{format}")
                  if asset_path?.length > 0
                    SOURCE
                      key: format
                      src: asset_path
                      type: "video/#{format}"

                "Your browser does not support the video element."
            else if feature.testimonial
              DIV 
                style: 
                  marginTop: 32

                DIV 
                  style: 
                    fontWeight: 400
                    fontSize: 22
                    fontStyle: 'italic'
                    color: '#666'
                  feature.testimonial.short_quote

                DIV 
                  style:
                    padding: '12px 16px'
                    verticalAlign: 'middle'  
                    textAlign: 'right'

                  DIV 
                    style: 
                      fontSize: 20
                      whiteSpace: 'nowrap'

                    feature.testimonial.name

                  DIV 
                    style: 
                      fontSize: 16
                      whiteSpace: 'nowrap'

                    feature.testimonial.role
                    ', '
                    feature.testimonial.organization



  componentDidMount: -> 
    if @refs.video && !@local.video_height?
      @local.video_height = @refs.video.getDOMNode().parentNode.offsetWidth * 1080/1920





tab_features = [
 {
  id: 'moderation'    
  label: 'Comment moderation'
  html: """
        <p>As a forum administrator, you have a number of options for hiding incivil and/or off-topic user posts using our moderation interface.</p>
        <p>But explicit moderation is usually unnecessary. We’ve found an even more powerful mechanism: a civility pledge that you can ask all forum participants to agree to upon account creation. It is amazing what setting expectations can do!</p> 
        <p>Moreover, <a href='#research'>academic studies</a> indicate that the structure of Consider.it forums lead to more civil discourse, so you may not have to worry. We have <a href='/examples'>hosted dialogues on very contentious issues</a> without having to moderate a single comment.</p> 
        <p>If you are still apprehensive about civility, <a href='/contact?form=consulting_inquiry'>contact us</a> and we can help you work through how to facilitate civil online discourse in your forum.</p>
        """
  img: asset('product_page/moderation.png')
  paid: true
 }

 {
  id: 'customization'
  label: 'Custom look & feel'
  html: 'We can work with you to design and implement a forum with the look and feel that you want. Moreover, we have a number of homepage templates that can organize your community’s ideas to best meet your needs.'
  img: asset('product_page/customize_homepage.gif')
  paid: true
 }


 {
  id: 'private_forums'    
  label: 'Private forums'
  html: """<p>By default, your Consider.it forum is public – anyone with a link can access your forum.
              With Private Forums, you can lock down your forum to only those you invite via email.</p>"""
  img: asset('product_page/private_forum.png')
 }

 {
  id: 'profile_questions'  
  label: 'Custom user info'
  html: """
        <p>You can ask for additional information from your stakeholders when they create an account on your forum.</p>
        <p>For example, you can ask if they are a Donating Member of your organization. Or you can ask if they are a homeowner. Or you can ask demographic questions like age and race.</p>
        <p>This information can then be used in our <a href='/tour?feature=opinion_analytics#features'>opinion analytics</a> for understanding what specific stakeholder segments think and why.</p>
        <p>The information is also available in <a href='/tour?feature=data_export#features'>data exports</a>.</p>
        """

  video: 'profile_questions'
  paid: true
 }

 {
  id: 'opinion_analytics'    
  label: 'Opinion analytics'
  html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can configure your forum so you can understand what different stakeholder segments think and why.'
  video: 'analytics'
  paid: true
 }
 {
  id: 'accessibility'  
  label: 'Disability accessibility'
  html: """
        <p>It is important to make our technologies accessible for as many people as possible, so everyone can equitably participate.</p>
        <p>Consider.it is <strong>Level A compliant</strong> with the <a href="https://www.w3.org/WAI/intro/wcag.php" target="_blank" style="text-decoration: underline;">Web Content Accessibility Guidelines (WCAG)</a>. Read our <a target="_blank" href="https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub">Accessibility Compliance Statement</a> for more information.</p>
        <p>Furthermore, Consider.it offers additional direct help for users of screenreaders. We help each of these folks individually to understand the proposals being discussed and input their opinions. </p>"""
  testimonial: testimonials.sheri 
 }
 {
  id: 'data_export'    
  label: 'Data export'
  html: 'Export your forum data into CSV format. We can work with you if you have other data requirements.'
  img: asset('product_page/data_export.png')
  paid: true
 }
 {
  id: 'translation'    
  label: 'Language translation'
  html: 'We offer interface translations for a number of languages, and can do additional translations with assistance. Furthermore, for multi-lingual websites, we offer Google Translate integration.'
  img: asset('product_page/translation.gif')
  paid: true
 }
 # {
 #  id: 'traffic_analytics'    
 #  label: 'Visitation metrics'
 #  html: 'Add Google Analytics to your forum to understand your forum’s traffic.'
 #  img: ''
 #  paid: true
 # } 

]  








# basic_features = [
#  {
#   id: 'opinion_slate'    
#   label: 'An Opinion Slate for your community'
#   html: 'Consider.it makes each stakeholder\'s opinion about whatever you\'re gathering feedback about visible. You\'ll get everyone on the same page quicker as a result.'
#   video: 'opinion_slate'  
#  }
#  {
#   id: 'proposals'    
#   label: 'Each proposal can be developed in detail'
#   html: 'Add as much detail to proposals as you wish, including embedding images or video. You control whether your community can post their own proposals.'
#   video: 'proposal_development'
#  }
#  {
#   id: 'slide_opinions'    
#   label: 'Express less partisan opinions with a sliding scale' #'See your opinion in relation to others'
#   html: 'Individuals slide their overall opinion about a proposal, integrating their opinion with others. The slider endpoints are configurable. You can set them to Agree/Disagree, High Priority/Low Priority or whatever your community is evaluating about a proposal.'
#   video: 'slide_it'   
#  }
#  {
#   id: 'pro_con_dialogue'    
#   label: 'Nuanced dialogue focuses on surfacing pros and cons'
#   html: 'Consider.it encourages stakeholders to think critically about the merits and disadvantages of an idea. In the margins, each participant can see the points of their peers, learn from them, and even include them in their own list of important points. Now your users are finding common ground with their peers!'
#   video: 'pro_con'
#  }
#  {
#   id: 'explore_opinions'    
#   label: 'Explore patterns of thought for deeper understanding'
#   html: 'Consider.it provides a dynamically updating, interactive summary of what your community thinks and why. You can drill deeper into the underlying reasons for different groups. For example, learn the reservations of those who oppose a proposal. Perhaps 80% of those with reservations share two con points that can be resolved, helping build consensus!'
#   video: 'explore'
#  }
#  {
#   id: 'encourage_civility'    
#   label: 'Set focus and encourage civility'
#   html: 'Consider.it helps participants focus on the issue, rather than each other. Personal attacks don’t make sense in the Pro/Con format. Individuals can have extended discussions about single points, but they’re contained and don’t hijack the overall conversation.'
#   video: 'drilldown'
#  } 

#  {
#   id: 'accessibility'  
#   label: 'Accessible for people with disabilities'
#   html: 'Consider.it is <a href="https://www.w3.org/WAI/intro/wcag.php" target="_blank" style="text-decoration: underline;">WCAG</a> Level A compliant. Consider.it also provides a mechanism for users of screenreaders to ask for help. We help each of these folks individually to understand the proposals being discussed and input their opinions. Read our <a target="_blank" href="https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub">Accessibility Compliance Statement</a> for more information.'
#   testimonial: testimonials.sheri 
#  }

#  {
#   id: 'private_forums'    
#   label: 'Private Forums'
#   html: """<p>By default, your Consider.it forum is public. That means that anyone with a link can access your forum.</p>
#            <p>With Private Forums, you can lock down your forum to only those you invite via email.</p>"""
#  }

# ]



paid_features = [
 {
  id: 'customization'
  label: 'Customized Look, Feel, and Functionality'
  html: 'We can work with you to design and implement a forum with the look and feel that you want for your brand. Moreover, we have a number of homepage templates that can organize your community’s ideas to best meet your needs.'
  img: asset('product_page/customize_homepage.gif')
 }

 {
  id: 'profile_questions'  
  label: 'Ask demographic and profile questions'
  html: 'You can ask for additional information from stakeholders when they create an account on your forum. For example, you can ask if they are a Donating Member of your organization. Or you can ask if they are a homeowner. Or you can ask demographic questions like age and race. This information is available in data exports. It can also be used in our opinion analytics described below.'
  video: 'profile_questions'
 }

 {
  id: 'opinion_analytics'    
  label: 'Opinion Analytics for survey-like cross-tabs'
  html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can help you understand the patterns of thoughts based on whatever segment you\'re interested in examining.'
  video: 'analytics'
 }

 {
  id: 'translation'    
  label: 'Multilingual forums & Google Translate'
  html: 'We offer interface translations in a number of languages, and can do translations to other languages with help. Furthermore, for multi-lingual websites, we offer Google Translate integration.'
  img: asset('product_page/translation.gif')
 }
 {
  id: 'moderation'    
  label: 'Content Moderation'
  html: 'You can choose to review content before it is publicly posted, or just enable moderation for review after posting. The moderation interface enables you to directly contact the author if you wish to ask them to revise a statement that violates community standards. Note that moderation is rarely burdonsome – even for contentious issues, Consider.it tends to foster civil interactions.'
  #img: asset('product_page/moderation.png')
 }
 {
  id: 'data_export'    
  label: 'Data export'
  html: 'Export your forum data into CSV format. We can work with you if you have other data requirements.'
  img: ''
 }
 {
  id: 'traffic_analytics'    
  label: 'Google Analytics integration'
  html: 'Add Google Analytics to your forum to understand your forum’s traffic.'
  img: ''
 } 

]  




Research = ReactiveComponent
  displayName:'Research'

  render: -> 
    authors = (author_list) -> 

      UL 
        style:
          display: 'inline'
          position: 'relative'
          left: 20

        for author,idx in author_list
          LI 
            key: idx
            style: 
              display: 'inline-block'
              listStyle: 'none'
              zIndex: 10 - idx
              position: 'absolute'
              left: 40 * idx
              top: 4 #* idx

            Avatar
              key: "/user/#{author}"
              user: "/user/#{author}"
              img_size: 'large'
              style: 
                width: 50
                height: 50


    papers = [
      {
        url: "http://www.sciencedirect.com/science/article/pii/S0747563215003891"
        title: 'Facilitating Personal Deliberation Online: Effects of Two Consider.it Variations'
        venue: 'Computers in Human Behavior, Volume 51, Part A'
        quote: """
          ...<b>working with Consider.it had significant and meaningful effects on 
          participants’ deliberation and deliberative attitudes</b>. The application urged participants 
          to reconsider and often change their original opinion, and the participants generally felt 
          their knowledge and understanding of the subject-matter had changed.
        """
        authors: [324679, 324678]
      },    
      {
        url: "https://dl.dropboxusercontent.com/u/3403211/papers/jitp.pdf"
        title: 'Facilitating Diverse Political Engagement'
        venue: 'Journal of Information Technology & Politics, Volume 9, Issue 3'
        quote: """
          Citizens rely on group identity cues to direct their political attentions, which 
          can lead to the views of opposing groups being ignored. But many [Consider.it] users 
          did engage with the ideas of users who took stances opposite their own. Over 
          one-third (33.7%) of point-considering stances recognized points written by 
          dissenting others and over half (56.4%) chose to read more about such points. 
          Taken together, these metrics show <b>[Consider.it] users embraced political 
          diversity in terms of both arguments and the stances of other users</b>.
        """      
        authors: [324669, 323666, 324672, 324671, 324670]
      },    
      {
        url: "http://dub.washington.edu/djangosite/media/papers/kriplean-cscw2012.pdf"
        title: 'Supporting Reflective Public Thought with Consider.it'
        venue: 'ACM Conference on Computer Supported Cooperative Work'
        quote: """
          …Given the partisan rancor of our political discourse, especially in online web forums, 
          one might expect few people participating in a public [Consider.it] online discussion 
          during a contentious election to acknowledge the importance of factors on both sides 
          of the debate. However, we found 41.4% of all Consider.it opinions included 
          both a pro and a con.
          """
        authors: [323666, 324672, 324669, 324670, 324671]
      },    
      {
        url: "http://homes.cs.washington.edu/~borning/papers/kriplean-cscw2014.pdf"
        title: 'On-demand Fact-checking in Public Dialogue'
        venue: 'ACM Conference on Computer Supported Cooperative Work'
        authors: [324673, 323666, 324670, 324675, 324674]
      }
    ]

    reveal = => 
      @local.show = !@local.show
      document.activeElement.blur()
      save @local 

    DIV 
      style: 
        minWidth: 500
        maxWidth: 700
        #margin: '40px 0'
        margin: 'auto'
        padding: '0px 16px'
      A name: 'research'

      H2 
        style: 
          fontSize: 42
          fontWeight: 800        
          paddingTop: 60
          fontStyle: 'oblique'


        SPAN 
          style: 
            color: '#8D8E8D'
          'How do you know Consider.it works?'

        SPAN 
          style: 
            color: primary_color()
          ' Has there been research?'




      DIV 
        className: 'embedded'
        style: 
          fontSize: 20
          maxWidth: 700
          margin: '12px auto'
          paddingBottom: 12
          color: 'black'
        dangerouslySetInnerHTML: 
          __html:
            """
              <p>Yes! Consider.it was invented at the University of Washington as 
                 part of the National Science Foundation funded <b>
                 <a href='#{asset('product_page/dissertation.pdf')}'>doctoral research</a></b> of 
                 Consider.it founder Travis Kriplean. Our research objective was to create 
                 a method by which large groups of people could civily 
                 deliberate together online and find common ground, even on contentious topics. The research was conducted in collaboration with colleagues 
                 in Computer Science, Political Communication, Statistics, and 
                 Human-centered Design.</p>
            """

      if @local.show 

        UL
          style: 
            listStyle: 'none'
            position: 'relative'
            margin: '20px 0px'
            paddingBottom: 40

          for paper, idx in papers
            left = false #idx % 2 == 1
            size = 20
            LI 
              key: paper.title
              style: 
                position: 'relative'
                marginBottom: 30

              DIV 
                style: 
                  display: 'inline-block'
                  textAlign: 'left'
                  #maxWidth: '80%'
                A 
                  style:  
                    color: '#303030'
                    fontSize: 28
                    fontWeight: 700
                    fontStyle: 'oblique'
                    lineHeight: 1.1
                    textDecoration: 'underline'

                  href: paper.url
                  paper.title
                DIV 
                  style: _.extend {}, small_text,
                    paddingTop: 8
                    lineHeight: 1.1
                  paper.venue


                DIV 
                  style: 
                    display: 'inline'
                    fontSize: 24
                    fontWeight: 800
                    fontStyle: 'oblique'
                    color: '#9C9C9C'
                    position: 'relative'
                    top: 18

                  'Authors: '
                
                authors paper.authors

              if paper.quote 
                DIV
                  style: css.crossbrowserify
                    padding: '36px 50px'
                    position: 'relative'
                    backgroundColor: considerit_gray
                    boxShadow: '#b5b5b5 0 1px 1px 0px'
                    borderRadius: 64
                    marginBottom: 40
                    flex: 1 #'1 auto' # '1 1 auto'
                    marginLeft: 80
                    marginTop: 70
                    maxWidth: 600
                    right: 0
                    display: 'inline-block'

                  DIV
                    style: css.crossbrowserify
                      transform:  "rotate(180deg) scale(-1,-1)"

                      position: 'absolute'
                      left: 56
                      top: -30
                      zIndex: 2

                    Bubblemouth 
                      apex_xfrac: 0
                      width: 30
                      height: 30
                      fill: considerit_gray
                      stroke: 'transparent'
                      stroke_width: 0
                      box_shadow:   
                        dx: -3 
                        dy: 0
                        stdDeviation: 2
                        opacity: .1

                  DIV
                    className: 'embedded'
                    style: 
                      fontSize: 16

                    DIV dangerouslySetInnerHTML: {__html: paper.quote}
      
      BUTTON 
        style: 
          border: 'none'
          backgroundColor: '#eee'
          #textDecoration: 'underline'
          fontSize: 22
          fontWeight: 600
          padding: '12px 24px'
          margin: '12px auto'
          color: '#303030'
          display: 'block'
          width: '100%'
        onClick: reveal
        onKeyPress: (e) =>
          if e.which == 32 || e.which == 13
            reveal()
            e.stopPropagation()
            e.preventDefault()


        "#{if @local.show then 'Hide' else 'Show'} research findings about Consider.it"



/** WEBPACK FOOTER **
 ** ./@client/product_page/tour.coffee
 **/